<ion-header class="remove-margin-from-safe-area ion-no-border">
  <ion-toolbar >
    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-toolbar>
          <ion-buttons slot="end">
            <ion-button (click)="closeModal()"  
              ><ion-icon color="dark" name="close"></ion-icon
            ></ion-button>
          </ion-buttons>
        </ion-toolbar>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col style="text-align: center;">
          <h2 class="subheader-regular">{{ ('keys.data.payments.confirm_payment' |
          translate : {Default:'Confirm Payment'}) || 'Confirm Payment' }}</h2>
        </ion-col>
      </ion-row>
    </ion-grid>
    
   
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid>
    <ion-row>
      <ion-col class="ion-no-padding"  size="12">
        <ion-item lines="none" class="paragraph-input-fields-regular">
        <ion-label 
          >{{ ('keys.data.common.subtotal' |
          translate : {Default:'Subtotal'}) || 'Subtotal' }}
         
        </ion-label>
        <span class="ion-text-wrap ion-text-right">
          {{cartTotal['sub_total'] | currency}}
        </span>
      </ion-item>
      </ion-col>
    </ion-row>
    <ion-row *ngFor="let tax of cartTotal['taxes']" >
      <ion-col *ngIf="tax?.amount" class="ion-no-padding">
        <ion-item  lines="none" class="paragraph-input-fields-regular">
          <ion-label>{{tax?.label}} {{tax?.percentage | round:3}}%</ion-label>
          <ion-label slot="end"
            >{{ tax?.amount | currency
            }}</ion-label
          >
        </ion-item>
      </ion-col>
    </ion-row>
    <ion-row >
    <ion-col class="ion-no-padding">
    <ion-item lines="none" class="paragraph-input-fields-bold">
      <ion-label  
        >{{ ('keys.data.common.total' |
        translate : {Default:'Total'}) || 'Total' }}
        
      </ion-label>
      <span class="ion-text-wrap ion-text-right">
        {{cartTotal['total']| currency}}
      </span>
    </ion-item>
    </ion-col>
    </ion-row>
    <ion-row>
      <ion-col >
        <ion-label class="paragraph-bold"> {{ ('keys.data.payments.payment_method' |
          translate : {Default:'Payment Method'}) || 'Payment Method' }}</ion-label>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="cartTotal['total']>0">
      <ion-col>
        <ion-card>
        <ion-item lines="none">
        <ion-label class="paragraph-bold">
          {{payType['PaymentTypeName']}}
        </ion-label>
      </ion-item>
    </ion-card>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="payType?.['promptFor']==null && cartTotal['total']==0">
      
      <ion-col style="text-align: center;">
        <ion-card>
        <ion-item lines="none" style="text-align: center;">
        <ion-label style="font-weight: bold">
          {{ ('keys.data.common.zero_dollar_item' |
          translate : {Default:'Zero Dollar Item'}) || 'Zero Dollar Item' }}
        </ion-label>
      </ion-item>
    </ion-card>
      </ion-col>
     </ion-row>
     <ion-row *ngIf="cartTotal['total']>0">
      <ion-col>
        <form [formGroup]="paymentForm">
          <ion-label *ngIf="payType['promptFor'].toLowerCase()=='anonymous' || payType['promptFor'].toLowerCase()=='billing'" class="paragraph-bold"> {{ ('keys.data.reports.user_details' |
            translate : {Default:'User Details'}) || 'User Details' }}</ion-label>
         
        <ion-grid>
          <ion-row *ngIf="payType['promptFor'].toLowerCase()=='anonymous'">
            <ion-col>
              <ion-card>
              <ion-item>
                <ion-label style="font-weight: bold">Email:</ion-label>
                <ion-input 
                  pattern="^[\w-\.]+@([\w-]+\.)+[\w-]{1,4}$"
                  [formControlName]="'email'"
                  required
                  type="email"
                ></ion-input>
              </ion-item>
            </ion-card>
            </ion-col>
          </ion-row>
          <ion-row *ngIf="payType['promptFor'].toLowerCase()=='billing'">
            <ion-col size="12">
              <ion-card>
              <ion-item>
                <ion-label  style="font-weight: bold">{{ ('keys.data.users_login.email' |
                  translate : {Default:'Email'}) || 'Email' }}:</ion-label>
                <ion-input 
                  pattern="^[\w-\.]+@([\w-]+\.)+[\w-]{1,4}$"
                  [formControlName]="'email'"
                  required
                  type="email"
                ></ion-input>
              </ion-item>
            </ion-card>
            </ion-col>
            <ion-col size="12">
              <ion-card>
              <ion-item>
                <ion-label style="font-weight: bold">{{ ('keys.data.profile.name' |
                  translate : {Default:'Full Name'}) || 'Full Name' }}:</ion-label>
                <ion-input 
                  [formControlName]="'name'"
                  required
                  type="text"
                ></ion-input>
              </ion-item>
            </ion-card>
            </ion-col>
            <ion-col size="12">
              <ion-card>
              <ion-item>
                <ion-label style="font-weight: bold">{{ ('keys.data.profile.phone_number' |
                  translate : {Default:'Phone Number'}) || 'Phone Number' }}:</ion-label>
                <ion-input 
                  [formControlName]="'phone_number'"
                  required
                  type="phone"
                ></ion-input>
              </ion-item>
            </ion-card>
            </ion-col>
            <ion-col size="12">
              <ion-card>
              <ion-item>
                <ion-label style="font-weight: bold">{{ ('keys.data.profile.address1' |
                  translate : {Default:'Address Line 1'}) || 'Address Line 1' }}:</ion-label>
                <ion-input 
                  [formControlName]="'address_1'"
                  required
                  type="text"
                ></ion-input>
              </ion-item>
            </ion-card>
            </ion-col>
            <ion-col size="12">
              <ion-card>
              <ion-item>
                <ion-label style="font-weight: bold">{{ ('keys.data.profile.address2' |
                  translate : {Default:'Address Line 2'}) || 'Address Line 2' }}:</ion-label>
                <ion-input 
                  [formControlName]="'address_2'"
                  type="text"
                ></ion-input>
              </ion-item>
            </ion-card>
            </ion-col>
            <ion-col size="12">
              <ion-card>
              <ion-item>
                <ion-label style="font-weight: bold">{{ ('keys.data.profile.city' |
                  translate : {Default:'City'}) || 'City' }}:</ion-label>
                <ion-input 
                  
                  [formControlName]="'city'"
                  
                  type="text"
                ></ion-input>
              </ion-item>
            </ion-card>
            </ion-col>
            <ion-col size="12">
              <ion-card>
              <ion-item>
                <ion-label style="font-weight: bold">{{ ('keys.data.common.province_or_state' |
                  translate : {Default:'Province or State'}) || 'Province or State' }}:</ion-label>
                  
                
                <ion-select 
                    required
                    multiple="false"
                    [formControlName]="'province'"
                  >
                    <ion-select-option
                      *ngFor="let v of provinces"
                      [value]="v.ProvID.toString()"
                      >{{ v.ProvName }}</ion-select-option
                    >
                  </ion-select>
              </ion-item>
            </ion-card>
            </ion-col>
            <ion-col size="12">
              <ion-card>
              <ion-item>
                <ion-label style="font-weight: bold">{{ ('keys.data.common.postalcode_or_zipcode' |
                  translate : {Default:'Postal Code/Zip Code'}) || 'Postal Code/Zip Code' }}:</ion-label>
                <ion-input 
                  
                  [formControlName]="'postal'"
                  required
                  type="text"
                ></ion-input>
              </ion-item>
            </ion-card>
            </ion-col>
          </ion-row>
          <ion-row *ngIf="payType['promptFor'].toLowerCase()=='creditcard'">
            <ion-col>
              <ion-card>
                  <ion-item >
                    <ion-label >{{ ('keys.data.payments.cardholder' |
                      translate : {Default:'Card Holder Name'}) || 'Card Holder Name' }}:</ion-label>
                    <ion-input required  type="text" formControlName="cardName"></ion-input>
                  </ion-item>
                </ion-card>
                <ion-card>
                  <ion-item >
                    <ion-label >{{ ('keys.data.payments.card_number' |
                      translate : {Default:'Card Number'}) || 'Card Number' }}:</ion-label>
                    <ion-input  maxlength="16" minlength="13" required  type="text" formControlName="cardNumber"></ion-input>
                  </ion-item>
                </ion-card>
                <ion-card>
                  <ion-item  >
                    <ion-label >{{ ('keys.data.payments.card_expiry' |
                      translate : {Default:'Card Expiry'}) || 'Card Expiry' }}:</ion-label>
                    <ion-select   required [interfaceOptions]="monthOptions" formControlName="cardExpiryMonth"   placeholder="Month">
                      <ion-select-option value="01">1</ion-select-option>
                      <ion-select-option value="02">2</ion-select-option>
                      <ion-select-option value="03">3</ion-select-option>
                      <ion-select-option value="04">4</ion-select-option>
                      <ion-select-option value="05">5</ion-select-option>
                      <ion-select-option value="06">6</ion-select-option>
                      <ion-select-option value="07">7</ion-select-option>
                      <ion-select-option value="08">8</ion-select-option>
                      <ion-select-option value="09">9</ion-select-option>
                      <ion-select-option value="10">10</ion-select-option>
                      <ion-select-option value="11">11</ion-select-option>
                      <ion-select-option value="12">12</ion-select-option>
                    </ion-select>
                    <ion-select  required [interfaceOptions]="yearOptions" formControlName="cardExpiryYear"   placeholder="Year">
                      <ion-select-option
                      *ngFor="let year of expiryDates"
                      [value]=year>{{year}}</ion-select-option>
                    </ion-select>
                  </ion-item>
                </ion-card>
                <ion-card>
                  <ion-item >
                    <ion-label >CVV:</ion-label>
                    <ion-input maxlength="4" minlength="3" required  type="text" formControlName="cardCVVD"></ion-input>
                  </ion-item>
                </ion-card>
            </ion-col>
          </ion-row>
          <ion-row *ngIf="payType?.['promptFor']!=null && payType['promptFor'].toLowerCase()=='campusCard'">
            <ion-col>
              <ion-card>
                  <ion-item >
                    <ion-label >{{ ('keys.data.payments.campuscard_barcode' |
                      translate : {Default:'CampusCard Barcode'}) || 'CampusCard Barcode' }}:</ion-label>
                    <ion-input required  type="text" formControlName="campusCardNumber"></ion-input>
                  </ion-item>
                </ion-card>
                <ion-card>
                  <ion-item >
                    <ion-label >{{ ('keys.data.profile.first_name' |
                      translate : {Default:'First Name'}) || 'First Name' }}:</ion-label>
                    <ion-input required  type="text" formControlName="firstName"></ion-input>
                  </ion-item>
                </ion-card>
                <ion-card>
                  <ion-item >
                    <ion-label >{{ ('keys.data.profile.last_name' |
                      translate : {Default:'Last Name'}) || 'Last Name' }}:</ion-label>
                    <ion-input required  type="text" formControlName="lastName"></ion-input>
                  </ion-item>
                </ion-card>
                <ion-card>
                  <ion-item id="date" >
                    <ion-label >{{ ('keys.data.profile.date_of_birth' |
                      translate : {Default:'Date of Birth'}) || 'Date of Birth' }}:</ion-label>
                      <ion-label >{{paymentForm.get('dateOfBirth').value | date:dataService.settings['system']['datemask']}}</ion-label>
                  </ion-item>
                </ion-card>
                  <ion-popover trigger="date" size="cover">
                    <ng-template>
                      <ion-datetime [max]="maxDate" [showDefaultButtons]="true"  presentation="date" required  formControlName="dateOfBirth"></ion-datetime>
                    </ng-template>
                  </ion-popover>
                 
                
            </ion-col>
          </ion-row>
          </ion-grid>
       </form
    >
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col >
        <ion-button  (click)="processPayment()" [disabled]="processLoading ||!paymentForm.valid" expand="block" color="primary">{{ ('keys.data.payments.make_payment' |
          translate : {Default:'Make Payment'}) || 'Make Payment' }}<ion-spinner *ngIf="processLoading"></ion-spinner> </ion-button>
        
      </ion-col>
    </ion-row>
    
  </ion-grid>

</ion-content>
